// WhatsappStatus.jsx
import React, { useState, useEffect } from 'react';
import AsideDefault from '@/views/components/AsideDefault';
import Container from '@/views/components/Container';
import TemplateContainer from '@/views/components/TemplateContainer';
import { StyledBodyContainer } from './styles';
import axios from 'axios';

const nodeServer = 'https://rdcwhats.permanence.com.br';

console.log(nodeServer);
const WhatsappStatus = () => {
    const user = localStorage.getItem('user');
  if (!['fabio', 'JoyceAnd', 'denys.fagundes', 'master'].includes(user)) {
    return <div style={{ padding: 40, color: 'red' }}>Acesso restrito</div>;
  }
  const [formPessoa, setFormPessoa] = useState(null);

  const [alertaPessoas, setAlertaPessoas] = useState([]);

  const fetchPessoas = async () => {
    try {
      const res = await axios.get(`${nodeServer}/pessoas`);
      setAlertaPessoas(res.data);
    } catch (err) {
      console.error('Erro ao carregar lista de alertas:', err);
    }
  };

  const editarPessoa = (pessoa) => {
    setFormPessoa(pessoa);
  };

  const excluirPessoa = async (id) => {
    if (window.confirm('Tem certeza que deseja remover esta pessoa?')) {
      try {
        await axios.delete(`${nodeServer}/pessoas/${id}`);
        fetchPessoas();
      } catch (err) {
        console.error('Erro ao excluir pessoa:', err);
      }
    }
  };

  const salvarPessoa = async () => {
    try {
      if (formPessoa.id_alerta_pessoa) {
        await axios.put(`${nodeServer}/pessoas/${formPessoa.id_alerta_pessoa}`, formPessoa);
      } else {
        await axios.post(`${nodeServer}/pessoas`, formPessoa);
      }
      setFormPessoa(null);
      fetchPessoas();
    } catch (err) {
      console.error('Erro ao salvar pessoa:', err);
    }
  };
  const [numero, setNumero] = useState('');
  const [nome, setNome] = useState('');
  const [ultimaConexao, setUltimaConexao] = useState(null);
  const [status, setStatus] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [inputNumero, setInputNumero] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchInitialStatus = async () => {
    try {
      const res = await axios.get(`${nodeServer}/whats/atual`);
      const { nome, numero, status, ultima_conexao } = res.data;
      if (!numero || status === 0) {
        setNumero('');
        setStatus('desconectado');
      } else {
        setNumero(numero);
        setStatus('conectado');
      }
      setNome(nome);
      setUltimaConexao(ultima_conexao);
    } catch (err) {
      console.error('Erro ao buscar status inicial do WhatsApp:', err);
      setNumero('');
      setStatus('desconectado');
    } finally {
      setLoading(false);
    }
  };

  const fetchStatus = async (phone) => {
    try {
      const res = await axios.get(`${nodeServer}/whats/${phone}`);
      setStatus(res.data.status);
      setQrCode(res.data.qr);
      setNumero(phone);
    } catch (err) {
      console.error('Erro ao buscar status do WhatsApp:', err);
      setStatus(null);
      setQrCode(null);
    }
  };

  const handleSubmit = async () => {
    if (inputNumero) {
      setLoading(true);
      try {
        await fetchStatus(inputNumero);
      } catch (err) {
        console.error('Erro ao conectar:', err);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleLogout = async () => {
    if (numero) {
      const confirm = window.confirm('Tem certeza que deseja desconectar este número?');
      if (!confirm) return;
      setLoading(true);
      try {
        await axios.get(`${nodeServer}/whats/${numero}/logout`);
        await fetchInitialStatus();
        setQrCode(null);
        setInputNumero('');
      } catch (err) {
        console.error('Erro ao desconectar:', err);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchInitialStatus();
    fetchPessoas();
  }, []);

  useEffect(() => {
    if (numero && ['qrcode', 'inicializando'].includes(status)) {
      const interval = setInterval(() => fetchStatus(numero), 5000);
      return () => clearInterval(interval);
    }
  }, [numero, status]);

  return (
    <section className='section'>
      <Container>
        <TemplateContainer>
          <AsideDefault>
            <p>Status do WhatsApp</p>
          </AsideDefault>
          <StyledBodyContainer>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <i className="fas fa-spinner fa-spin" style={{ fontSize: '24px', marginBottom: 10 }}></i>
                <p>Carregando...</p>
              </div>
            ) : (
              <>
                {status === 'conectado' && (
                  <div style={{ color: 'green', fontWeight: 'bold' }}>
                    ✅ Conectado com sucesso
                    <br />
                    {nome && <div><strong>Nome:</strong> {nome}</div>}
                    {numero && <div><strong>Número:</strong> {numero}</div>}
                    {ultimaConexao && <div><strong>Última conexão:</strong> {new Date(ultimaConexao).toLocaleString()}</div>}
                    <button className="button full-width" onClick={handleLogout} style={{ marginTop: 20, padding: 10, width: '100%' }}>
                      🔌 Desconectar
                    </button>
                  </div>
                )}

                {(!numero || status !== 'conectado') && (
                  <>
                    <p style={{ color: 'red' }}>Informe o número do WhatsApp para iniciar sessão.</p>
                    <div style={{ marginTop: 20 }}>
                      <input
                        type="text"
                        placeholder="Ex: 5511999999999"
                        value={inputNumero}
                        onChange={(e) => setInputNumero(e.target.value.trim())}
                        style={{ padding: 8, width: '100%' }}
                      />
                      <button className="button full-width"
                        onClick={handleSubmit}
                        style={{ marginTop: 10, padding: 10, width: '100%' }}
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>
                            Conectando...
                          </>
                        ) : 'Gerar QR Code'}
                      </button>
                    </div>
                  </>
                )}
                {qrCode && status === 'qrcode' && (
                  <div style={{ marginTop: 20 }}>
                    <p>Escaneie o código abaixo com o WhatsApp:</p>
                    <img src={qrCode} alt="QR Code" style={{ width: 300 }} />
                    <p>Após scanear, aguarde até que o status seja informado... leva cerca de 60 segundos.</p>
                  </div>
                )}
              </>
            )}
            <hr style={{ margin: '2rem 0' }} />

            <div>
              <h3>Destinatários de Alerta ({alertaPessoas.filter(p => p.status === 1).length} ativos)</h3>
              <p>Aqui você poderá cadastrar ou editar os números e e-mails que recebem alertas.</p>
              <table style={{ width: '100%', marginTop: '1rem', borderCollapse: 'collapse', textAlign: 'left', border: '1px solid #ccc' }}>
                <thead>
                  <tr>
                    <th style={{ border: '1px solid #ddd', padding: '8px', background: '#eee' }}>Nome</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', background: '#eee' }}>Número</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', background: '#eee' }}>Email</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', background: '#eee' }}>Status</th>
                    <th style={{ border: '1px solid #ddd', padding: '8px', background: '#eee' }}>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {alertaPessoas.map((pessoa, index) => (
                    <tr key={pessoa.id_alerta_pessoa} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
                      <td style={{ border: '1px solid #ddd', padding: '6px' }}>{pessoa.nome}</td>
                      <td style={{ border: '1px solid #ddd', padding: '6px' }}>{pessoa.numero}</td>
                      <td style={{ border: '1px solid #ddd', padding: '6px' }}>{pessoa.email}</td>
                      <td style={{ border: '1px solid #ddd', padding: '6px' }}>{pessoa.status === 1 ? 'Ativo' : 'Inativo'}</td>
                      <td style={{ border: '1px solid #ddd', padding: '6px', textAlign: 'center' }}>
                        <button onClick={() => editarPessoa(pessoa)} style={{ marginRight: 6 }}>✏️</button>
                        <button onClick={() => excluirPessoa(pessoa.id_alerta_pessoa)}>🗑️</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="button full-width" style={{ marginTop: '1rem' }} onClick={() => editarPessoa({ nome: '', numero: '', email: '', status: 1 })}>
                ➕ Adicionar novo
              </button>
              {formPessoa && (
                <div style={{ marginTop: '1rem', padding: '1rem', border: '1px solid #ccc' }}>
                  <h4>{formPessoa.id_alerta_pessoa ? 'Editar' : 'Nova'} Pessoa</h4>
                  <input
                    placeholder="Nome"
                    value={formPessoa.nome}
                    onChange={(e) => setFormPessoa({ ...formPessoa, nome: e.target.value })}
                    style={{ marginBottom: 6, width: '100%' }}
                  />
                  <input
                    placeholder="Número"
                    value={formPessoa.numero}
                    onChange={(e) => setFormPessoa({ ...formPessoa, numero: e.target.value })}
                    style={{ marginBottom: 6, width: '100%' }}
                  />
                  <input
                    placeholder="Email"
                    value={formPessoa.email}
                    onChange={(e) => setFormPessoa({ ...formPessoa, email: e.target.value })}
                    style={{ marginBottom: 6, width: '100%' }}
                  />
                  <select
                    value={formPessoa.status}
                    onChange={(e) => setFormPessoa({ ...formPessoa, status: Number(e.target.value) })}
                    style={{ marginBottom: 6, width: '100%' }}
                  >
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                  </select>
                  <button className="button full-width" onClick={salvarPessoa} style={{ marginRight: 10 }}>💾 Salvar</button>
                  <button className="button full-width" onClick={() => setFormPessoa(null)}>❌ Cancelar</button>
                </div>
              )}
            </div>
          </StyledBodyContainer>
        </TemplateContainer>
      </Container>
    </section>
  );
};
export default WhatsappStatus;


